<template>
<div v-if="step==='AUTH'" class="window formWrap" >
  <div class="d-flex flex-column blockWrapper">
    <h4 class="formSubtitle">Авторизация</h4>
    <!-- <p class="info-note ">Вам будет отправлен код для подтверждения вашего номера</p>
    <p class="small"> (Если у Вас ранее был зарегистрирован аккаунт на портале Про100 Квиз с номером телефона, то необходимо указать этот номер для объединения прежнего аккаунта с профилем ВКонтакте. Иначе будет создан новый аккаунт)</p> -->
  </div>
  <div class="contacts contacts__modal">
    <div class="contact__inputs">
      <MyInput
         label="Телефон"
         ref="phoneInput"
         phone-input
         data-tel-input
         autocomplete="tel"
         type="tel"
         maxlength="18"
         v-model="userPhone"
         v-on:keyup.enter="sendPhone"
      ></MyInput>
    </div>
    <div v-if="errorPhoneModal" class="invalid-feedback">ЧТО-ТО НЕ ТАК!</div>
  </div>
  <div class="d-flex gap-2">
    <my-button type="button" @click="sendPhone" class="flex-grow-1 wizard-send-phone" id="submit_phone_and_name_btn">
      <span>
        ОТПРАВИТЬ КОД
      </span>
      <span v-if="pending" class="spinner-grow spinner-grow-sm ms-3" role="status" aria-hidden="true"></span>
    </my-button>
    <my-button v-if="showSkipButton" hidden type="button" @click="skipPhone" class="btn-skip" id="skip_phone_btn">
      <span>ПРОПУСТИТЬ</span>
    </my-button>
  </div>
</div>

<div v-if="step==='CONFIRM'" class="window formWrap" >
  <div class="d-flex flex-column blockWrapper">
    <h4 class="formSubtitle">Авторизация</h4>
    <p v-if="codeSendBy==='whatsapp'" class="info-note ">Введите 4-х значный код, отправленный вам в WhatsApp на номер <strong>{{userPhone}}</strong>, для подтверждения.</p>
    <p v-else-if="codeSendBy==='sms_aero'" class="info-note ">Введите 4-х значный код, отправленный вам в SMS на номер <strong>{{userPhone}}</strong>, для подтверждения.</p>
    <p v-else-if="codeSendBy==='flash_call'" class="info-note ">Авторизация через вызов. На номер <strong>{{userPhone}}</strong> поступит звонок. Введите последние 4-ре цифры номера входящего звонка.</p>
    <p v-else class="info-note ">Введите 4-х значный код, отправленный вам на номер <strong>{{userPhone}}</strong>, для подтверждения.</p>
    <p v-if="errorCodeModal" class="info-note mb-0 mt-3 py-2 alert alert-danger">{{errorCodeModal}}</p>
  </div>
  <div class="position-relative">
  <MyInput label="Код подтверждения"
           ref="inputCode"
           phone-input
           type="text"
           v-model="validateCode"
           v-on:keyup.enter="sendValidateCode"
           maxlength="4"
           class="nameModal"
           id="validCodeModal"
           autocomplete="off"
  ></MyInput>
  <div class="loaderInInput">
    <span v-if="pending" class="spinner-grow spinner-grow-sm ms-3" role="status" aria-hidden="true"></span>
  </div>
  </div>

  <my-button :cls="!canResendCode?'hollow':''" @click="sendPhone" class="w-100">
    <span>ОТПРАВИТЬ СНОВА</span>
    <span v-if="resendTimer" class="ms-3">{{resendTimer}}</span>
  </my-button>
</div>

<div v-if="step==='USERNAME'" class="window formWrap">
    <h4 class="formTitle">Авторизация</h4>
      <div class="d-flex flex-column">
        <p class="formSubtitle">Мы еще не знакомы.<br> Напишите ваше имя.</p>
      </div>
      <div class="position-relative">

      <MyInput label="Имя"
               ref="inputName"
               name-input
               type="text"
               maxlength="18"
               v-model="userName"
               v-on:keyup.enter="setUserName"
               class="nameModal mb-4" id="nameModal" placeholder="Имя" autocomplete="off"
      ></MyInput>
      <div class="loaderInInput">
        <span v-if="pending" class="spinner-grow spinner-grow-sm ms-3" role="status" aria-hidden="true"></span>
      </div>
      </div>
    <div class="modal-footer set-name-footer">
      <my-button @click="setUserName" type="button" class="btn btn-primary" id="submit_name__btn">
          <span>
              Сохранить
          </span>
      </my-button>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import MyInput from "@/components/UI/MyInput";
// import VkAuthButton from "@/components/VkAuthButton";

const TIMEOUT = 5

export default {
  name: "WizardLogin",
  components: {
    MyInput,
    // VkAuthButton
  },
  props: {
    showSkipButton: {
      type: Boolean,
      default: false
    }
  },
  emits: ['otp-sent', 'otp-validated', 'skip-phone'],
  data: function () {
    return {
      step: 'AUTH',
      userPhone: '',
      validateCode: '',
      userName: '',
      errorPhoneModal: '',
      errorCodeModal: '',
      resolvePromise: undefined,
      rejectPromise: undefined,
      pending: false,
      canResendCode: false,
      lastResendTimer: 0,
      resendTimer: TIMEOUT,
      resendTimerInterval: null,
      codeSendBy: null,
      showVkTestButton: false,
    }
  },
  watch: {
    validateCode() {
      if (`${this.validateCode}`.length>3) this.sendValidateCode();
    },
    step(step){
      if (step==='CONFIRM'){
        this.startTimer()
      }
    }
  },
  mounted() {
    this.auth()
    this.checkVkButtonVisibility()
  },
  methods: {
    checkVkButtonVisibility() {
      // Проверяем видимость кнопки через бэкенд для безопасности
      this.$api.checkVkAuthButtonVisibility()
        .then((response) => {
          this.showVkTestButton = response.show_vk_button || false
        })
        .catch((error) => {
          console.warn('Failed to check VK button visibility:', error)
          // Fallback: проверка через cookie для локального тестирования
          this.showVkTestButton = this.hasVkTestCookie()
        })
    },
    hasVkTestCookie() {
      // Fallback метод для локального тестирования
      return document.cookie.split(';').some(c => c.trim().startsWith('show_test_vk_button='))
    },
    ...mapActions([
      'SET_USER_TOKEN',
      'SET_USER_FIELDS',
      'GET_USER_DETAILS',
      'SHOW_AUTH_MODAL'
    ]),
    startTimer(){
      if (this.resendTimerInterval) clearInterval(this.resendTimerInterval)
      this.canResendCode = false
      this.lastResendTimer += TIMEOUT
      this.resendTimer = this.lastResendTimer
      this.resendTimerInterval = setInterval(()=>{
        if (this.resendTimer>0){
          this.resendTimer-=1
        } else {
          this.canResendCode=true
          clearInterval(this.resendTimerInterval)
        }
      }, 1000)
    },
    auth() {
      this.step = 'AUTH';
      this.$nextTick(()=> {
        this.$refs.phoneInput.focus();
        this.glb.phoneInputFormatter();
      });
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    sendPhone: function () {
      let vm = this;
      if (vm.pending || (vm.step==='CONFIRM' && !vm.canResendCode)) return
      vm.pending = true
      vm.$logApi.log({
        logs:{
          event: 'user login',
          phone: vm.userPhone,
          timestamp: new Date().toISOString(),
        }
      })
      // Используем новый API для отправки OTP кода
      vm.$api.sendWizardOtpCode(vm.userPhone)
        .then((res)=>{
            vm.codeSendBy = res.send_by
            vm.step = 'CONFIRM'
            vm.$nextTick(()=>vm.$refs.inputCode.focus())
            // Отправляем событие о том, что OTP отправлен
            vm.$emit('otp-sent', {
              phone: vm.userPhone,
              code: res.code
            })
        })
        .catch(function (error) {
          if (error.response && error.response.data){
            let errorMessage = ''
              for (let key in error.response.data) {
                errorMessage += `${key}: ${error.response.data[key]}\n`
              }
              console.log('auth error')
              console.log(errorMessage)
              vm.$toast.error("Что-то пошло не так на нашей стороне. Мы уже чиним, попробуйте авторизоваться чуть позже, спасибо!")
          } else {
            console.log('auth error')
            console.log(error)
            vm.$toast.error("Что-то пошло не так на нашей стороне. Мы уже чиним, попробуйте авторизоваться чуть позже, спасибо!")
          }
          console.log("Что-то пошло не так на нашей стороне. Мы уже чиним, попробуйте авторизоваться чуть позже, спасибо!")
        })
        .finally(()=>{
          vm.pending = false
          vm.startTimer()
        })
    },
    skipPhone: function () {
      // Пропуск ввода номера телефона
      this.$emit('skip-phone')
    },
    sendValidateCode: function () {
      let vm = this;
      if (vm.pending) return
      vm.pending = true
      // Отправляем OTP код в родительский компонент для обработки
      vm.$emit('otp-validated', {
        phone: vm.userPhone,
        code: vm.validateCode
      })
      vm.pending = false
    },
    setUserName: function () {
      let vm = this;
      if (vm.pending) return
      vm.pending = true
      vm.$api.updateUserPut({'first_name': vm.userName})
        .then(function (response) {
          vm.finishAuth(response.data)
        })
        .catch(function (error){
          vm.$toast.error(error);
        }).finally(()=>vm.pending = false)
    },
    async finishAuth(data) {
      this.SET_USER_FIELDS(data);
      await this.GET_USER_DETAILS();
      this.step = ''
      this.validateCode = ''
      this.userPhone = ''
      this.userName = ''
      if (this.$store.state.targetClick) {
        console.log('TARGET CLICK >> ', this.$store.state.targetClick);
        try{
          this.$store.state.targetClick.click();
        } finally {
          this.$store.dispatch('SET_TARGET_CLICK_ELEMENT', null)
        }
      }
      if (this.$route.query.from) {
        console.log('REDIRECT TO', this.$route.query.from);
        this.$router.push(this.$route.query.from)
      } else if (this.$route.name === 'login'){
        this.$router.push('/')
      }
      this.resolvePromise()
    },
    handleVkAuthSuccess(data) {
      // Обработка успешной авторизации через VK
      this.finishAuth(data);
    },
    handleVkAuthError(error) {
      // Ошибка уже обработана в VkAuthButton, здесь можно добавить дополнительную логику
      console.error('VK Auth Error in Login component:', error);
    },
    resetStep() {
      this.step = 'AUTH'
      this.validateCode = ''
      this.userPhone = ''
      this.userName = ''
      this.errorPhoneModal = ''
      this.errorCodeModal = ''
    }

  },
  beforeUnmount() {
    if (this.rejectPromise) this.rejectPromise()
    if (this.resendTimerInterval) clearInterval(this.resendTimerInterval)
  }
}
</script>

<style scoped>
.modal-footer {
  border: none;
}
.window {
  max-width: 340px;
  margin: 0 auto;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.loaderInInput{
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(50%, -50%);
  margin-right: 3rem;
}
.vk-auth-container{
  margin: 10px 10px 20px 40px;
}
.btn-skip {
  background: transparent;
  border: 2px solid #6c757d;
  color: #6c757d;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  white-space: nowrap;
  font-size: x-small;
}
.btn-skip:hover {
  background: #6c757d;
  color: white;
  font-size: x-small;
}
.gap-2 {
  gap: 0.5rem;
  flex-direction: row;
  justify-content: center;
}
.flex-grow-1 {
  flex-grow: 1;
}

.wizard-send-phone {
  font-size: smaller;
}
</style>